import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const IsEligibleForDiscountRequest = z.object({
  storeId: z.string(),
  couponName: z.string(),
  publicUserId: z.string(),
})

export type IsEligibleForDiscountRequest = z.infer<typeof IsEligibleForDiscountRequest>

export const IsEligibleForDiscountResponse = z.discriminatedUnion('tag', [
  z.object({
    tag: z.literal('nonEligible'),
  }),
  z.object({
    tag: z.literal('eligible'),
  }),
])

export type IsEligibleForDiscountResponse = z.infer<typeof IsEligibleForDiscountResponse>

export const isEligibleForDiscountDeclaration = endpointDeclaration(
  IsEligibleForDiscountRequest,
  IsEligibleForDiscountResponse,
)
